import { useCallback } from 'react';
import { notification } from 'antd';

const useClipboard = () => {
  const copyToClipboard = useCallback((text) => {
    navigator.clipboard.writeText(text).then(
      () => {
        notification.success({
          message: 'Copied to clipboard',
          description: 'The text has been copied to your clipboard.',
          duration: 3,
          placement: 'topRight',
        });
      },
      (err) => {
        console.error('Failed to copy text: ', err);
        notification.error({
          message: 'Copy failed',
          description: 'Failed to copy the text to your clipboard.',
          duration: 3,
          placement: 'topRight',
        });
      }
    );
  }, []);

  return copyToClipboard;
};

export default useClipboard;